import request from '../utils/request';

export function getAlerts(params) {
    return request({
        url: '/auth/alerts',
        method: 'get',
        params
    });
}
